/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */
/**
 * Available PDF page formats when generating PDF documents.
*/
export var PDFPageFormat;
(function (PDFPageFormat) {
    PDFPageFormat["FitToPages"] = "FIT_TO_PAGES";
    PDFPageFormat["A4"] = "A4";
    PDFPageFormat["A4Landscape"] = "A4_LANDSCAPE";
    PDFPageFormat["A5"] = "A5";
    PDFPageFormat["A5Landscape"] = "A5_LANDSCAPE";
    PDFPageFormat["Letter"] = "LETTER";
    PDFPageFormat["LetterLandscape"] = "LETTER_LANDSCAPE";
    PDFPageFormat["Legal"] = "LEGAL";
    PDFPageFormat["LegalLandscape"] = "LEGAL_LANDSCAPE";
})(PDFPageFormat || (PDFPageFormat = {}));
/**
 * Available page source types when generating image files from scanned or imported pages.
 */
export var PageSourceType;
(function (PageSourceType) {
    /**
    * Uncut, unfiltered image as delivered by camera.
    */
    PageSourceType["Original"] = "ORIGINAL";
    /**
    * Cut and filtered image.
    */
    PageSourceType["CutFilter"] = "CUT_FILTER";
    /**
    * Cut only image, no filter.
    */
    PageSourceType["CutOnly"] = "CUT_ONLY";
})(PageSourceType || (PageSourceType = {}));
/**
 * Available log level for defining the level of logging detail
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["Disable"] = "DISABLE";
    LogLevel["Assert"] = "ASSERT";
    LogLevel["Error"] = "ERROR";
    LogLevel["Warning"] = "WARNING";
    LogLevel["Info"] = "INFO";
    LogLevel["Debug"] = "DEBUG";
    LogLevel["Verbose"] = "VERBOSE";
})(LogLevel || (LogLevel = {}));
/**
 * Available filters that can be applied on scanned documents.
 */
export var ScanFilter;
(function (ScanFilter) {
    ScanFilter["Auto"] = "AUTO";
    ScanFilter["Gray"] = "GRAY";
    ScanFilter["BlackWhite"] = "BLACKWHITE";
    ScanFilter["Original"] = "ORIGINAL";
    ScanFilter["Text"] = "TEXT";
    ScanFilter["Auto2"] = "AUTO2";
    ScanFilter["Illustration"] = "ILLUSTRATION";
})(ScanFilter || (ScanFilter = {}));
/**
 * Available sources for the document scanner.
 */
export var Source;
(function (Source) {
    /**
    * Scan a document by using the devices camera.
    */
    Source["Camera"] = "CAMERA";
    /**
    * Scan a document from the provided image.
    */
    Source["Image"] = "IMAGE";
    /**
    * Open an image picker in single selection mode and scan a document from the selected image.
    */
    Source["Gallery"] = "GALLERY";
    /**
    * Open an image picker in multi selection mode and scan documents from the selected images.
    */
    Source["GalleryMultiple"] = "GALLERY_MULTIPLE";
})(Source || (Source = {}));
/**
 * Available statusbar appearances.
 */
export var StatusBarAppearance;
(function (StatusBarAppearance) {
    /**
     * Light appearance.
     */
    StatusBarAppearance["Light"] = "LIGHT";
    /**
     * Dark appearance.
     */
    StatusBarAppearance["Dark"] = "DARK";
})(StatusBarAppearance || (StatusBarAppearance = {}));
/**
 * Available navigationbar appearances.
 */
export var NavigationBarAppearance;
(function (NavigationBarAppearance) {
    /**
     * Light appearance.
     */
    NavigationBarAppearance["Light"] = "LIGHT";
    /**
     * Dark appearance.
     */
    NavigationBarAppearance["Dark"] = "DARK";
})(NavigationBarAppearance || (NavigationBarAppearance = {}));
//# sourceMappingURL=model.js.map